module.exports = __webpack_public_path__ + "img/en-bg-address.35f9c9cc.svg";